import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Payment } from '../../../api/models';

@Component({
  selector: 'app-payment-refund-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>Refund Payment</h2>
    <mat-dialog-content>
      <form [formGroup]="refundForm" class="flex flex-col gap-4">
        <p class="text-sm text-gray-600">
          Refunding transaction <strong>{{ data.transactionId || data.id }}</strong>
          for order #{{ data.orderId }}.
        </p>
        
        <mat-form-field>
          <mat-label>Refund Amount</mat-label>
          <span matPrefix>$&nbsp;</span>
          <input matInput type="number" formControlName="amount" min="0.01" [max]="data.amount">
          <mat-error *ngIf="refundForm.get('amount')?.hasError('required')">Amount is required</mat-error>
          <mat-error *ngIf="refundForm.get('amount')?.hasError('min')">Amount must be greater than 0</mat-error>
          <mat-error *ngIf="refundForm.get('amount')?.hasError('max')">Cannot refund more than original amount (\${{ data.amount }})</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Reason</mat-label>
          <textarea matInput formControlName="reason" rows="3" placeholder="e.g., Customer complaint, Order cancelled"></textarea>
          <mat-error *ngIf="refundForm.get('reason')?.hasError('required')">Reason is required</mat-error>
        </mat-form-field>

      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="warn" [disabled]="refundForm.invalid" (click)="onSubmit()">
        <mat-icon class="mr-2">undo</mat-icon>
        Confirm Refund
      </button>
    </mat-dialog-actions>
  `
})
export class PaymentRefundDialogComponent {
  refundForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PaymentRefundDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Payment
  ) {
    this.refundForm = this.fb.group({
      amount: [data.amount, [Validators.required, Validators.min(0.01), Validators.max(data.amount)]],
      reason: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.refundForm.valid) {
      this.dialogRef.close(this.refundForm.value);
    }
  }
}
